/* Lazy product lists: Shopify product recommendations and recently viewed products. */
(function () {
  'use strict';

  function whenVisible(element, callback) {
    if (!('IntersectionObserver' in window)) {
      callback();
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0].isIntersecting) return;
        observer.disconnect();
        callback();
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    // Observe the section wrapper so hidden (display:none) elements still trigger loading.
    observer.observe(element.hidden ? element.closest('.shopify-section') || element : element);
  }

  function hideSection(element) {
    const section = element.closest('.shopify-section');
    if (section) section.classList.add('is-empty');
  }

  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.children.length || this._loading) return;
      this._loading = true;
      whenVisible(this, () => {
        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const doc = new DOMParser().parseFromString(text, 'text/html');
            const fresh = doc.querySelector('product-recommendations');
            if (fresh && fresh.querySelector('.product-list__item')) this.innerHTML = fresh.innerHTML;
            else hideSection(this);
          })
          .catch(() => hideSection(this));
      });
    }
  }
  if (!customElements.get('product-recommendations')) customElements.define('product-recommendations', ProductRecommendations);

  class RecentlyViewed extends HTMLElement {
    connectedCallback() {
      if (this._loading) return;
      this._loading = true;
      this.track = this.querySelector('[data-slider-track]');
      let handles = [];
      try {
        handles = JSON.parse(localStorage.getItem('theme:recently-viewed') || '[]');
      } catch (error) {
        handles = [];
      }
      const exclude = this.dataset.exclude;
      const limit = parseInt(this.dataset.limit, 10) || 8;
      handles = handles.filter((h) => h && h !== exclude).slice(0, limit);
      if (!handles.length || !this.track) {
        if (!window.Shopify || !window.Shopify.designMode) hideSection(this);
        return;
      }
      whenVisible(this, () => this.load(handles));
    }

    async load(handles) {
      const root = (window.theme.routes.root || '/').replace(/\/$/, '');
      const results = await Promise.all(
        handles.map((handle) =>
          fetch(`${root}/products/${encodeURIComponent(handle)}?section_id=product-card-render`)
            .then((response) => (response.ok ? response.text() : ''))
            .catch(() => '')
        )
      );
      const items = results
        .map((html) => {
          if (!html) return null;
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const card = doc.querySelector('[data-product-card]');
          return card ? card.outerHTML : null;
        })
        .filter(Boolean);
      if (!items.length) {
        hideSection(this);
        return;
      }
      this.track.innerHTML = items.map((card) => `<li class="product-list__item">${card}</li>`).join('');
      this.hidden = false;
      const slider = this.querySelector('slider-component');
      if (slider && typeof slider.update === 'function') slider.update();
    }
  }
  if (!customElements.get('recently-viewed')) customElements.define('recently-viewed', RecentlyViewed);
})();
